import { render, staticRenderFns } from "./MedicineMngtReg.vue?vue&type=template&id=0a6bedeb"
import script from "./MedicineMngtReg.vue?vue&type=script&lang=js"
export * from "./MedicineMngtReg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports